import React from 'react';

import {CategoryProps} from 'modules/categories/types';
import Row from 'shared/components/row';
import {SemiBoldText} from 'shared/components/text';

const Category: React.FC<CategoryProps> = ({name, products = []}) => {
  return (
    <Container>
      <Title>
        <SemiBoldText size="medium">{name}</SemiBoldText>
      </Title>
      <Row
        flexWrap="wrap"
        style={{
          alignItems: 'stretch',
        }}
        gap={30}>
        {products.map((product) => (
          <Product key={product.id} {...product} />
        ))}
      </Row>
    </Container>
  );
};

export default Category;

import styled from 'styled-components';
import Product from './product';

export const Container = styled.div`
  background-color: white;
`;

export const Title = styled.div`
  padding: 15px 0;
`;
